import { useMutation, useQueryClient } from '@tanstack/react-query';
import { feedbackApi } from '../api/feedback';

/**
 * PATCH /api/eraf/catalog/feedback/{id} {status:'ANSWERED', answer} — ROLE_ADMIN 전용
 * 답변 등록(queue #684 §UAT-2026-07-14-R684 §R684-3① — RECEIVED→ANSWERED 전이 시 answer 필수).
 * 성공 시 관리 목록 + 제출자 본인 목록(mine) invalidate.
 */
export function useAnswerFeedback() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, answer }: { id: number; answer: string }) =>
      feedbackApi.updateStatus(id, { status: 'ANSWERED', answer }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['common-showcase', 'feedback', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['common-showcase', 'feedback', 'mine'] });
    },
  });
}
